/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 * @enum {string}
 */
export enum QuotePurpose {
  Sellable = "Sellable",
  Testing = "Testing",
  Benchmark = "Benchmark",
  Reference = "Reference",
}

export function instanceOfQuotePurpose(value: any): boolean {
  for (const key in QuotePurpose) {
    if (Object.prototype.hasOwnProperty.call(QuotePurpose, key)) {
      if (QuotePurpose[key as keyof typeof QuotePurpose] === value) {
        return true;
      }
    }
  }
  return false;
}

export function QuotePurposeFromJSON(json: any): QuotePurpose {
  return QuotePurposeFromJSONTyped(json, false);
}

export function QuotePurposeFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): QuotePurpose {
  return json as QuotePurpose;
}

export function QuotePurposeToJSON(value?: QuotePurpose | null): any {
  return value as any;
}

export function QuotePurposeToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): QuotePurpose {
  return value as QuotePurpose;
}
